import { createContext, useContext } from 'react';

interface EmbeddedContextType {
  isEmbedded: boolean;
}

const EmbeddedContext = createContext<EmbeddedContextType>({ isEmbedded: false });

const useEmbedded = (): EmbeddedContextType => useContext(EmbeddedContext);

export { EmbeddedContext, useEmbedded };
